export const interests = [
  'Mathematics',
  'Science',
  'Programming',
  'Literature',
  'History',
  'Art',
  'Web Development',
  'Data Science',
  'Islamic Studies',
  'Graphic Design',
  'Machine Learning',
];
